var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","background-color":"var(--grey_alpha)"}},[_c('div',{staticClass:"graph",staticStyle:{"background-color":"white"}},[_c('network',{ref:"network",attrs:{"nodes":_vm.nodes,"edges":_vm.edges,"options":_vm.options}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222c954c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Graph.vue
// module id = null
// module chunks = 